import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const StrategicResource = () => {
  const { t } = useLang();
  const s = t.strategic;

  return (
    <section id="biochar" className="bg-white border-b border-border" data-testid="strategic">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-6">
            <Reveal>
              <Overline index="01">{s.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
                {s.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <Reveal delay={0.1}>
              <p className="font-body text-lg leading-relaxed text-zinc-600">{s.text}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border-t border-l border-border">
          {s.attributes.map((a, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                className="group h-full border-b border-r border-border p-6 lg:p-8 hover:bg-nero-ink transition-colors duration-300"
                data-testid={`strategic-attr-${i}`}
              >
                <span className="font-heading text-xs font-bold text-nero-green">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="mt-3 font-heading text-lg font-medium tracking-tight text-nero-ink group-hover:text-white transition-colors">
                  {a}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
